import React from 'react';

function UnCheckedBox() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 2.5C15.2467 2.5 19.5 6.7533 19.5 12C19.5 17.2467 15.2467 21.5 10 21.5C4.7533 21.5 0.5 17.2467 0.5 12C0.5 6.7533 4.7533 2.5 10 2.5Z" stroke="#525365"/>
    </svg>

  );
}

export default UnCheckedBox;